import React, { useEffect, useState } from "react";
import "./OTIFChart.scss";
import { Chart } from "chart.js";
import { OTIF_CHART_DATA } from "./OTIFChart.data";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import { useSelector } from "react-redux";
import { UserState } from "../../redux/user/userReducer";
import { userDetails } from "../../redux/user/userSelector";

const OTIFChart: React.FC = () => {
  const user: UserState = useSelector(userDetails);
  const [loading, setLoading] = useState<boolean>(true);
  const vvv = false;

  useEffect(() => {
    getOtifDetails();
  }, []);

  const getOtifDetails = async () => {
    try {
      setLoading(true);

      const { data } = await ApiService().client.get(
        URLS.DASHBOARD.OTIF_DETAILS(user.company_id || -1)
      );
      // if (res.status === 200) {
      //  canvas and DOM settle before rendering
      setTimeout(() => {
        otifConsumptionRender(data.labels, data.values);
      }, 100);
      // }
    } catch (err) {
      console.error("Error: Fetching Otif Detail ", err);
    } finally {
      setLoading(false);
    }
  };

  const otifConsumptionRender = async (labels: string[], values: number[]) => {
    await clearOtifChart();
    const canvas = document.getElementById("otif-graph") as HTMLCanvasElement;

    if (!canvas) return;

    canvas.setAttribute("height", `${10 * 14 + 30}px`);
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    gradient.addColorStop(0, "#5151EC");
    gradient.addColorStop(1, "#85B2F4");

    const chart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: labels, // ✅ Use labels from backend
        datasets: [
          {
            label: "OTIF %",
            data: values,
            backgroundColor: gradient,
            barThickness: 10,
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 10,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 100,
            ticks: {
              color: "#9CA3AF",
              callback: (value: string | number) => `${value}%`,
              font: {
                size: 12,
                weight: 500,
                family: "Inter",
              },
              align: "center",
            },
            grid: {
              display: true,
            },
            border: {
              display: false,
            },
          },
          x: {
            offset: true,
            grid: {
              display: false,
            },
            ticks: {
              color: "#333333",
              font: {
                size: 12,
                lineHeight: 1.5,
                weight: 500,
                family: "Inter",
              },
            },
          },
        },
      },
    });
  };

  const clearOtifChart = async () => {
    const chartStatus = Chart.getChart("otif-graph"); // <canvas> id
    if (chartStatus != undefined) {
      chartStatus.destroy();
    }
  };

  return (
    <div className="otif-main-chart-container py-12 px-8 flex-column gap-16">
      <p className="xetgo-font-tag bold heading">OTIF %</p>
      {loading ? (
        <div className="empty-state-report-otif-chart-loader flex-row align-items-center flex-1 justify-content-center">
          <div className="mini-loader"></div>
        </div>
      ) : (
        <div className="vendor-graph-container">
          <canvas id="otif-graph"></canvas>
        </div>
      )}
    </div>
  );
};

export default OTIFChart;
